"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActionsContainer = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const oxygen_theme_1 = __importDefault(require("@8x8/oxygen-theme"));
const { novo } = oxygen_theme_1.default;
exports.ActionsContainer = styled_components_1.default.div `
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: ${novo.spacing03} ${novo.spacing05};
`;
